// extracted by mini-css-extract-plugin
export var container = "_hx-1";
export var cornerButtonContainer = "_hx-6";
export var disabled = "_hx-2";
export var dragActive = "_hx-3";
export var fileContainer = "_hx-5";
export var hiddenInput = "_hx-4";
export var widthContainer = "_hx-0";